export function dataURLtoFile(dataUrl: any, filename?: any) {
  let arr = dataUrl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

//Image file names
export enum fileNames {
  PROFILE_IMAGE_FILENAME = "profile_image.jpg",
  FRONT_DNI_FILENAME = "front_dni.jpg",
  BACK_DNI_FILENAME = "back_dni.jpg",
  INSURANCE_FILENAME = "insurance.jpg",
  TECHNICAL_REVIEW_PHOTO_1_FILENAME = "technical_review_photo_1.jpg",
  FRONT_LICENSE_FILENAME = "front_licence.jpg",
  BACK_LICENSE_FILENAME = "back_licence.jpg",
  ART_PHOTO_1_FILENAME = "art_photo_1.jpg",
  ART_PHOTO_2_FILENAME = "art_photo_2.jpg",
  CRIMINAL_RECORD_PHOTO_1_FILENAME = "criminal_record_photo_1.jpg",
  CRIMINAL_RECORD_PHOTO_2_FILENAME = "criminal_record_photo_2.jpg",
  OTHER_CERTIFICATE_PHOTO_1_FILENAME = "other_certificate_photo_1.jpg",
  OTHER_CERTIFICATE_PHOTO_2_FILENAME = "other_certificate_photo_2.jpg",
  EVENT_BICYCLE_PHOTO_FILENAME = "bicycle.jpg",
  EVENT_OBSERVATION_PHOTO_FILENAME = "observation.jpg",
  EVENT_OBSERVATION_PHOTO_2_FILENAME = "observation2.jpg",
  EVENT_OBSERVATION_PHOTO_3_FILENAME = "observation3.jpg",
}
